<div class="page-title-area title-img-one">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="page-title-text">
                <h2>Practice Areas</h2>

                <ul>
                    <li><a [routerLink]="homeUrl">Home</a></li>
                    <li><i class="icofont-simple-right"></i></li>
                    <li>Practice Areas</li>
                </ul>
            </div>
        </div>
    </div>
</div>

<section class="practice-area practice-area-three pt-100">
    <div class="container">
        <div class="row">
            <div class="col-sm-6 col-lg-4">
                <div class="practice-item">
                    <div class="practice-icon">
                        <i class="flaticon-law"></i>
                    </div>
                    <h3>Alternate Dispute Resolution and Arbitration</h3>
                    <p>Dispute resolution is an indispensable process for making social life peaceful. Dispute resolution process tries to...</p>
                    <a (click) = "navigateToDetails('ADR Law')">Read More</a>
                    <img class="practice-shape-one" src="assets/img/home-one/7.png" alt="Shape">
                    <img class="practice-shape-two" src="assets/img/home-one/8.png" alt="Shape">
                </div>
            </div>

            <div class="col-sm-6 col-lg-4">
                <div class="practice-item">
                    <div class="practice-icon">
                        <i class="flaticon-experience"></i>
                    </div>
                    <h3>Management and Labour Employment Law </h3>
                    <p>Workers are protected by the Labour Employment Law as per the constitution of Pakistan. We offer experienced...</p>
                    <a (click) = "navigateToDetails('Labour Law')">Read More</a>
                    <img class="practice-shape-one" src="assets/img/home-one/7.png" alt="Shape">
                    <img class="practice-shape-two" src="assets/img/home-one/8.png" alt="Shape">
                </div>
            </div>

            <div class="col-sm-6 col-lg-4">
                <div class="practice-item">
                    <div class="practice-icon">
                        <i class="flaticon-auction"></i>
                    </div>
                    <h3>Regulatory and Administrative Law </h3>
                    <p>We regularly practice before administrative agencies and commissions at the federal, provincial...</p>
                    <a (click) = "navigateToDetails('Admin Law')">Read More</a>
                    <img class="practice-shape-one" src="assets/img/home-one/7.png" alt="Shape">
                    <img class="practice-shape-two" src="assets/img/home-one/8.png" alt="Shape">
                </div>
            </div>

            <div class="col-sm-6 col-lg-4">
                <div class="practice-item">
                    <div class="practice-icon">
                        <i class="flaticon-money-bag"></i>
                    </div>
                    <h3>Commercial and Banking</h3>
                    <p>Commercial lending is an important area of practice for us. Although our expertise covers the spectrum of commercial lending transactions, the bulk of our work falls into two areas...</p>
                    <a (click) = "navigateToDetails('Banking Law')">Read More</a>
                    <img class="practice-shape-one" src="assets/img/home-one/7.png" alt="Shape">
                    <img class="practice-shape-two" src="assets/img/home-one/8.png" alt="Shape">
                </div>
            </div>

            <div class="col-sm-6 col-lg-4">
                <div class="practice-item">
                    <div class="practice-icon">
                        <i class="flaticon-balance"></i>
                    </div>
                    <h3>Litigation Group</h3>
                    <p>We handle virtually all kinds of civil, criminal, and commercial litigation at the administrative, trial court, and appellate levels and through the various channels of alternative...</p>
                    <a (click) = "navigateToDetails('Litigation Law')">Read More</a>
                    <img class="practice-shape-one" src="assets/img/home-one/7.png" alt="Shape">
                    <img class="practice-shape-two" src="assets/img/home-one/8.png" alt="Shape">
                </div>
            </div>

            <div class="col-sm-6 col-lg-4">
                <div class="practice-item">
                    <div class="practice-icon">
                        <i class="flaticon-vulnerability"></i>
                    </div>
                    <h3>Corporate and Securities</h3>
                    <p>Corporate law is the medium on which predominately all of our firm’s practice is based. We advise closely-held businesses as well as publicly traded corporations in a wide variety of areas...</p>
                    <a (click) = "navigateToDetails('Corporate Law')">Read More</a>
                    <img class="practice-shape-one" src="assets/img/home-one/7.png" alt="Shape">
                    <img class="practice-shape-two" src="assets/img/home-one/8.png" alt="Shape">
                </div>
            </div>

            <div class="col-sm-6 col-lg-4">
                <div class="practice-item">
                    <div class="practice-icon">
                        <i class="flaticon-mortarboard"></i>
                    </div>
                    <h3>Intellectual Property</h3>
                    <p>We have experts who can deal with your needs, as they are fully aware of the technical as well as legal complications in the field of intellectual property. As the use and importance of technology in...</p>
                    <a (click) = "navigateToDetails('Intellectual Law')">Read More</a>
                    <img class="practice-shape-one" src="assets/img/home-one/7.png" alt="Shape">
                    <img class="practice-shape-two" src="assets/img/home-one/8.png" alt="Shape">
                </div>
            </div>

            <div class="col-sm-6 col-lg-4">
                <div class="practice-item">
                    <div class="practice-icon">
                        <i class="flaticon-team"></i>
                    </div>
                    <h3>Constitutional and Public Interest</h3>
                    <p>Every individual and business have rights under the constitution and they have an inherent right to enjoy the constitutional securities and rights. However, at times these are violated...</p>
                    <a (click) = "navigateToDetails('Constitutional Law')">Read More</a>
                    <img class="practice-shape-one" src="assets/img/home-one/7.png" alt="Shape">
                    <img class="practice-shape-two" src="assets/img/home-one/8.png" alt="Shape">
                </div>
            </div>

            <div class="col-sm-6 col-lg-4">
                <div class="practice-item">
                    <div class="practice-icon">
                        <i class="flaticon-time"></i>
                    </div>
                    <h3>Estate Planning</h3>
                    <p>We offer professional advisors who are familiar with your goals and concerns, your assets and how they are owned, and your family structure. It covers the transfer of property at death as well...</p>
                    <a (click) = "navigateToDetails('Estate Law')">Read More</a>
                    <img class="practice-shape-one" src="assets/img/home-one/7.png" alt="Shape">
                    <img class="practice-shape-two" src="assets/img/home-one/8.png" alt="Shape">
                </div>
            </div>

            <div class="col-sm-6 col-lg-4">
                <div class="practice-item">
                    <div class="practice-icon">
                        <i class="flaticon-medal"></i>
                    </div>
                    <h3>Advisory and Transaction</h3>
                    <p>Over time, we have realized that to provide a legal structure to a transaction, the same has to be supported by the financial aspect of the transaction to make it a one window viable solution...</p>
                    <a (click) = "navigateToDetails('Advisory Law')">Read More</a>
                    <img class="practice-shape-one" src="assets/img/home-one/7.png" alt="Shape">
                    <img class="practice-shape-two" src="assets/img/home-one/8.png" alt="Shape">
                </div>
            </div>

            <div class="col-sm-6 col-lg-4">
                <div class="practice-item">
                    <div class="practice-icon">
                        <i class="flaticon-family"></i>
                    </div>
                    <h3>Family and Custody Law</h3>
                    <p>Child welfare is the key factor taken into consideration by the court while granting custodial rights to any parent. Thus, aspects such as financial stability of parent, reported misconduct, character....</p>
                    <a (click) = "navigateToDetails('Family Law')">Read More</a>
                    <img class="practice-shape-one" src="assets/img/home-one/7.png" alt="Shape">
                    <img class="practice-shape-two" src="assets/img/home-one/8.png" alt="Shape">
                </div>
            </div>

            <div class="col-sm-6 col-lg-4">
                <div class="practice-item">
                    <div class="practice-icon">
                        <i class="flaticon-vulnerability"></i>
                    </div>
                    <h3>Criminal Law</h3>
                    <p>The fundamentals of criminal law are based on the principle of justice, equity and good conscience. They provide adequate guidelines for the formulation of a rational penal policy. In order to be influential the criminal law....</p>
                    <a (click) = "navigateToDetails('Criminal Law')">Read More</a>
                    <img class="practice-shape-one" src="assets/img/home-one/7.png" alt="Shape">
                    <img class="practice-shape-two" src="assets/img/home-one/8.png" alt="Shape">
                </div>
            </div>
        </div>
    </div>
</section>